import "core-js/modules/es.array.index-of.js";
import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import store from '../../store';
import router from '../../router/SLXC';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar

import 'nprogress/nprogress.css'; // progress bar style

import { getToken, removeToken } from '@/utils/auth'; // get token from cookie

import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

function hasPermission(permissiomRouters, toPath) {
  return true; // if (!toPath) {
  //   menuTree.forEach(e => {
  //     if (e.path.indexOf(toPath) > 0) {
  //       return true
  //     } else {
  //       if (e.children.length > 0) {
  //         e.children.forEach(sub => {
  //           if (sub.path.indexOf(toPath) > 0) {
  //             return true
  //           }
  //         })
  //       }
  //     }
  //     return false
  //   })
  // }
  // if (menuTree.indexOf('admin') >= 0) return true // admin permission passed directly
  // if (!permissionRoles) return true
  // return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

var whiteList = ['/login', '/sso', '/simpleSso']; // no redirect whitelist

router.beforeEach(
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            NProgress.start(); // set page title

            console.log('title');
            document.title = getPageTitle(to.meta.title, '文化宫管理平台'); // determine whether the user has logged in

            hasToken = getToken();

            if (hasToken) {
              if (to.path === '/login') {
                // if is logged in, redirect to the home page
                next({
                  path: '/'
                });
                NProgress.done();
              } else {
                if (to.path === '/' || to.path === '/dashboard') {
                  store.commit('app/SET_MENUID', '');
                }

                if (store.getters.menuTree.length === 0) {
                  // 判断当前用户是否已拉取完user_info信息
                  store.dispatch('GetUserInfo').then(function (res) {
                    // 拉取user_info
                    // const menuTree = res.data.data.menuTreeVo // note: roles must be a array! such as: ['editor','develop']
                    document.title = getPageTitle(to.meta.title, '文化宫管理平台');
                    store.dispatch('GenerateRoutes', res.data.data).then(function () {
                      // 根据roles权限生成可访问的路由表
                      router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表

                      next(_objectSpread(_objectSpread({}, to), {}, {
                        replace: true
                      })); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                    });
                  }).catch(function (err) {
                    store.dispatch('FedLogOut').then(function () {
                      Message.error(err || 'Verification failed, please login again');
                      next({
                        path: '/'
                      });
                    });
                  });
                } else {
                  if (to.path.indexOf('realTime') > -1) {
                    store.commit('SET_ISREAL', '1');
                  } else {
                    store.commit('SET_ISREAL', '0');
                    store.commit('SET_REAL_FILTER', null);
                    store.commit('SET_ALARM_DATA', []);
                  }

                  if (hasPermission(store.getters.permission_routers, to.path)) {
                    console.log('addRoutes', to.path);
                    next(); //
                  } else {
                    next({
                      path: '/401',
                      replace: true,
                      query: {
                        noGoBack: true
                      }
                    });
                  }
                } // const hasGetUserInfo = store.getters.name
                // if (hasGetUserInfo) {
                //   next()
                // } else {
                //   try {
                //     // get user info
                //     await store.dispatch('user/getInfo')
                //     next()
                //   } catch (error) {
                //     // remove token and go to login page to re-login
                //     await store.dispatch('user/resetToken')
                //     Message.error(error || 'Has Error')
                //     next(`/login?redirect=${to.path}`)
                //     NProgress.done()
                //   }
                // }

              }
            } else {
              /* has no token*/
              if (whiteList.indexOf(to.path) !== -1) {
                // in the free login whitelist, go directly
                next();
              } else {
                // other pages that do not have permission to access are redirected to the login page.
                next("/login?redirect=".concat(to.path));
                NProgress.done();
              }
            }

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});